import { User } from '@geovelo-frontends/commons';
import React, { ReactNode } from 'react';
import { Navigate } from 'react-router';

export function GuestRoute({
  currentUser,
  defaultPrivatePath,
  children,
}: {
  children?: ReactNode;
  currentUser: User | null | undefined;
  defaultPrivatePath: string;
}): React.JSX.Element {
  if (currentUser) return <Navigate to={{ pathname: defaultPrivatePath }} />;

  return <>{children}</>;
}
